import React, { LegacyRef } from 'react';
import { css } from 'linaria';
import { SectionSubTitle, SignSection } from 'common/components';
import { KITCHEN_SIGN_SECTION_GALLERY_LIST } from 'common/components/kitchen';
import { KITCHEN_ELEMENT_BLOCK, KITCHEN_SIGN_UP_HREF } from '../../../kitchen-constants';
import { KitchenSignSectionPanel } from './components';

export const kitchenSignSection = css`
  @media (--from-desktop) {
    padding-bottom: 40px;
  }
`;

const kitchenSignSectionTitle = css`
  && {
    width: 456px;
    margin-bottom: 8px;

    @media (--to-desktop) {
      width: 414px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

type KitchenSignSectionProps = {
  calculatorHref: string;
  elementBlock: string;
  isRuRegion: boolean;
  panelRef: LegacyRef<HTMLDivElement>;
  signUpHref: string;
};

export const KitchenSignSection: React.FC<KitchenSignSectionProps> = ({
  calculatorHref, elementBlock, panelRef, isRuRegion, signUpHref
}) => (
  <SignSection
    className={kitchenSignSection}
    elementBlock={KITCHEN_ELEMENT_BLOCK}
    elementName="Приезжайте в гости — посмотрите кухни вживую"
    galleryList={KITCHEN_SIGN_SECTION_GALLERY_LIST}
    signHref={KITCHEN_SIGN_UP_HREF}
    renderTitle={() => (
      <SectionSubTitle className={kitchenSignSectionTitle} margin="s" color="text-invert">
        Приезжайте в&nbsp;гости&nbsp;&mdash; посмотрите кухни вживую
      </SectionSubTitle>
    )}
    renderAddContent={() => (
      <KitchenSignSectionPanel
        elementBlock={elementBlock}
        calculatorHref={calculatorHref}
        isRuRegion={isRuRegion}
        panelRef={panelRef}
        signUpHref={signUpHref} />
    )}
  />
);
